// import { parseResponse } from "helpers/common.lib";
// import { baseApi } from "../../redux/baseAPI";
import axios from "axios";
import { baseApi } from "../redux/baseAPI";
import { parseResponse } from "../helper";

export const referralsApi = baseApi.injectEndpoints({
  tagTypes: ["Referrals", "FollowupActions","ReferalMeta", "ExternalProviders"],
  endpoints: (builder) => ({
    getReferalNumber: builder.query({
      query: () => {
        return {
          url: `/Utilities/referral_random_num.json`,
          method: "GET",
          params: { prefix: 'REF' },
        };
      },
      transformResponse: (response, meta, arg) => response.response.data,
    }),
    getReferrals: builder.query({
      query: (queryParams) => {
        return {
          url: `/referrals/search_list.json`,
          method: "GET",
          params: queryParams,
        };
      },
      transformResponse: (response, meta, arg) => response.response.data,
      providesTags: (result) =>
        result
          ? [
            ...result.map(({ id }) => ({ type: "Referrals", id })),
            { type: "Referrals", id: "LIST" },
          ]
          : [{ type: "Referrals", id: "LIST" }],
    }),
    getReferralsMeta: builder.query({
      query: (params) => {
        return {
          url: `/referrals/meta.json`,
          method: "GET",
          params: params || {},
        };
      },
      providesTags:["ReferalMeta"],
      transformResponse: (response, meta, arg) => {
        const { data } = parseResponse(response);
        return data;
      },
     
    }),
    getReferralsFollowup: builder.query({
      query: (params) => {
        return {
          url: `/referrals/get_referral_contact_history.json`,
          method: "GET",
          params: params || {},
        };
      },
      transformResponse: (response, meta, arg) => {
        const { data } = parseResponse(response);
        return data;
      },
      providesTags: ["FollowupActions"]
    }),
    deleteReferral: builder.mutation({
      query: (payload) => {
        return {
          url: `/referrals/remove.json`,
          method: "POST",
          data: payload,
          params: {
            current_loc: `patient/encounter/provider_note/referral`,
            audit_encounter_id: payload.encounter,
          },
        };
      },
      transformResponse: (response, meta, arg) => response.response,
      invalidatesTags: [{ type: "Referrals" }],
    }),
    searchReferrals: builder.query({
      query: (queryParams) => {
        return {
          url: `/referrals/search_list.json`,
          method: "GET",
          params: queryParams,
        };
      },
      transformResponse: (response, meta, arg) => response.response.data,
      providesTags: (result) =>
        result
          ? [
            ...result.map(({ id }) => ({ type: "Referrals", id })),
            { type: "Referrals", id: "LIST" },
          ]
          : [{ type: "Referrals", id: "LIST" }],
    }),
    updateReferrals: builder.mutation({
      // note: an optional `queryFn` may be used in place of `query`
      query: (body) => {
        return {
          url: `/referrals/save.json`,
          method: "POST",
          data: body,
          params: { pid: body.pid },
        }
      },
      transformResponse: (response, meta, arg) => response.response,
      async onQueryStarted({ id, ...patch }, { dispatch, queryFulfilled }) {
        const patchResult = dispatch(
          referralsApi.util.updateQueryData("getReferrals", id, (draft) => {
            Object.assign(draft, patch);
          })
        );
        try {
          await queryFulfilled;
        } catch {
          patchResult.undo();
        }
      },
      invalidatesTags: ["Referrals"],
    }),
    updateReferralFollowup: builder.mutation({
      query: (body) => {
        return {
          url: `/referrals/add_referral_contact_history.json`,
          method: "POST",
          data: body,
          params: { pid: body.pid },
        }
      },
      transformResponse: (response, meta, arg) => response.response,
      async onQueryStarted({ id, ...patch }, { dispatch, queryFulfilled }) {
        const patchResult = dispatch(
          referralsApi.util.updateQueryData("getReferralsFollowup", id, (draft) => {
            Object.assign(draft, patch);
          })
        );
        try {
          await queryFulfilled;
        } catch {
          patchResult.undo();
        }
      },
      invalidatesTags: ["FollowupActions"],
    }),
    removeReferralFollowup: builder.mutation({
      query: (body) => {
        return {
          url: `/referrals/delete_referral_contact_history.json`,
          method: "POST",
          data: body,
          params: { pid: body.pid },
        }
      },
      transformResponse: (response, meta, arg) => response.response,
      async onQueryStarted({ id, ...patch }, { dispatch, queryFulfilled }) {
        const patchResult = dispatch(
          referralsApi.util.updateQueryData("getReferralsFollowup", id, (draft) => {
            Object.assign(draft, patch);
          })
        );
        try {
          await queryFulfilled;
        } catch {
          patchResult.undo();
        }
      },
      invalidatesTags: ["FollowupActions"],
    }),
    changeUrgency: builder.mutation({
      query: (body) => {
        return {
          url: `/referrals/set_urgency.json`,
          method: "POST",
          data: body,
          params: body,
        }
      },
      invalidatesTags: [{ type: "Referrals" }],
    }),

    externalProviders: builder.query({
      query: (params) => {
        return {
          url: `/external_providers/search_list.json`,
          method: "GET",
          params: params || {},
        };
      },
      providesTags:["ExternalProviders"],
    }),
    externalProvidersMeta: builder.query({
      query: (params) => {
        return {
          url: `/demographics/meta_data_address.json`,
          method: "GET",
          params: params || {},
        };
      },
    }),
    addExternalProvider: builder.mutation({
      query: (payload) => {
        return {
          url: `/externalProviders/add.json`,
          method: "POST",
          data: payload,
          //params: payload,
        };
      },
      transformResponse: (response, meta, arg) => response.response,
      invalidatesTags: [{ type: "ExternalProviders" }],
    }),
    
  }),
});

export const {
  useGetReferralsQuery,
  useGetReferralsMetaQuery,
  useGetReferralsFollowupQuery,
  useDeleteReferralMutation,
  useSearchReferralsQuery,
  useUpdateReferralsMutation,
  useUpdateReferralFollowupMutation,
  useRemoveReferralFollowupMutation,
  useChangeUrgencyMutation,
  useExternalProvidersQuery,
  useExternalProvidersMetaQuery,
  useAddExternalProviderMutation
} = referralsApi;

export const fetchProblemWithLinkFlag=(payload)=>{
  return axios.get(
    `${process.env.REACT_APP_API_URL_V1}/ccm/fetch_patient_problems_with_linked_flag.json?pid=${payload.pid}`,
  );
}